import { ReactNode } from 'react';
import { Alert, AlertDescription } from '@bliks-io/ui';
import { AlertCircle } from 'lucide-react';

type AlertVariant = 'warning' | 'info';

interface ReviewAlertProps {
  variant: AlertVariant;
  title: ReactNode;
  description: ReactNode;
}

const variantStyles = {
  warning: {
    alert: 'border-l-4 border-l-warning-solid bg-warning-surface',
    icon: 'h-5 w-5 text-warning',
    title: 'font-medium text-warning-strong mb-1',
    description: 'text-warning-strong'
  },
  info: {
    alert: 'border-l-4 border-l-info-solid bg-info-surface',
    icon: 'h-5 w-5 text-info',
    title: 'font-medium text-info-strong mb-1',
    description: 'text-info-strong'
  }
};

/**
 * Configurable alert for review modals with preset color variants
 * Supports warning (yellow) and info (blue) variants
 */
export function ReviewAlert({ variant, title, description }: ReviewAlertProps) {
  const styles = variantStyles[variant];

  return (
    <Alert className={styles.alert}>
      <AlertCircle className={styles.icon} />
      <AlertDescription className="text-sm">
        <div className={styles.title}>{title}</div>
        <div className={styles.description}>{description}</div>
      </AlertDescription>
    </Alert>
  );
}
